import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { DetailFormService } from 'tnx-admin-service/detailform/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'detailform',
    templateUrl: './detailform.component.html',
    styleUrls: ['./detailform.component.scss'],
    providers: [ComponentContextService],
})
export class DetailFormComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _detailFormService: DetailFormService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._detailFormService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'soThuTu', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'idColumn', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: 'Mã' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'soThuTu' }),
            new ColumnSchemaBase({ field: 'idColumn' }),
            new ColumnSchemaBase({ field: 'code' })
        ];

        super.ngOnInit();
    }
}

